<template>
    <v-btn-toggle
        v-model="screen"
        class="rounded-lg"
        @change="toggleView()"
    >
        <v-btn value="desktop-view" :class="{'disable-events': screen == 'desktop-view'}" data-testid="desktop-button">
            <v-icon>mdi-monitor</v-icon>
        </v-btn>
        <v-btn value="mobile-view" :class="{'disable-events': screen == 'mobile-view'}" data-testid="mobile-button">
            <v-icon>mdi-cellphone</v-icon>
        </v-btn>
    </v-btn-toggle>
</template>

<script>
export default {
    data(){
        return{
            screen: 'desktop-view'
        }
    },
    methods:{
        toggleView(){
            this.$emit('toggleView', this.screen)
        }
    }
}
</script>